<template>
  <div class="one-item">
    <div class="one-item__title">{{ title }}</div>
    <div class="one-item__price" :class="amountClass">
      {{ showDollarSymbol ? '$' : '' }} {{ amount }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    amount: {
      required: false,
      type: [Number, String],
      default() {
        return 0;
      }
    },
    showDollarSymbol: {
      required: false,
      type: Boolean,
      default() {
        return true;
      }
    },
    amountClass: {
      required: false,
      type: String
    }
  }
};
</script>
